import loadable from '@loadable/component';

export const LoadableNewbuildingOffersCarousel = loadable(() => import('../../../packages/Carousel/Carousel'));
